const isProduction = process.env.NODE_ENV === 'production' || window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
export const BASE_URL = isProduction ? '' : (process.env.REACT_APP_API_URL || 'http://127.0.0.1:5001');

async function request(endpoint: string, options: RequestInit = {}) {
    const token = localStorage.getItem('access_token');
    const isFormData = options.body instanceof FormData;

    const headers: Record<string, string> = {
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...((options.headers as Record<string, string>) || {}),
    };

    if (!isFormData && !headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }

    const response = await fetch(`${BASE_URL}${endpoint}`, { ...options, headers });

    if (!response.ok) {
        if (response.status === 401) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('is_admin');
            window.location.reload();
        }
        const errorData = await response.json();
        throw new Error(errorData.message || 'API request failed');
    }

    return response.json();
}

export const api = {
    get: (endpoint: string, options?: RequestInit) => request(endpoint, { method: 'GET', ...options }),
    post: (endpoint: string, body: any, options?: RequestInit) => {
        const isFormData = body instanceof FormData;
        return request(endpoint, {
            method: 'POST',
            body: isFormData ? body : JSON.stringify(body),
            ...options
        });
    },
    put: (endpoint: string, body: any, options?: RequestInit) => {
        const isFormData = body instanceof FormData;
        return request(endpoint, {
            method: 'PUT',
            body: isFormData ? body : JSON.stringify(body),
            ...options
        });
    },
    delete: (endpoint: string, options?: RequestInit) => request(endpoint, { method: 'DELETE', ...options }),
    generatePrototypePackage: (cantiereId: number, objectName: string, lprtSerial: string) =>
        api.post(`/user/cantiere/${cantiereId}/object/${objectName}/generate-prototype`, { lprt_serial: lprtSerial }),
};
